export default {
  listaStatusOdontograma: [],
  statusOdontograma: {
    id: null,
    nome: '',
    descricao: '',
    corHex: '',
    ativo: true,
  },
}
